<div class="flex items-cenetr justify-center minimal-height">
  <div class="flex-1 bg-red-100 hidden md:flex bg-center bg-cover" style="background-image: url('bg.jpg')"></div>
  <div class="flex-1 center-all p-4">
    <div class="max-w-[400px] shadow-xl shadow-black/3 bg-white rounded-2xl p-8">
      @if (resetStep() > 0) {
        <button type="button" class="mb-5 text-sm text-gray-500 hover:text-primary" (click)="closePasswordReset()">
          <i class="fa fa-chevron-left mr-2"></i>Back to login
        </button>
        <h1 class="h1-title mb-2">Reset password</h1>
        @if (resetStep() === 1) {
          <small class="mb-8 block text-gray-400">Enter your account email to receive a 6-digit code.</small>
          <form class="flex flex-col gap-4" (submit)="requestPasswordReset($event)">
            <div>
              <label for="reset-email">Email</label>
              <input id="reset-email" name="resetEmail" class="w-full" pInputText type="email" required email [(ngModel)]="resetEmail">
            </div>
            <button [disabled]="resetLoading() || !resetEmail()" class="btn-base bg-primary text-white" type="submit">
              @if (resetLoading()) { <i class="fa fa-spinner animate-spin"></i> } @else { Send reset code }
            </button>
          </form>
        } @else if (resetStep() === 2) {
          <small class="mb-8 block text-gray-400">Enter the code sent to {{ resetEmail() }}. It expires in 5 minutes.</small>
          <form class="flex flex-col gap-4" (submit)="verifyPasswordResetCode($event)">
            <div>
              <label for="reset-otp">6-digit code</label>
              <input id="reset-otp" name="resetOtp" class="w-full" pInputText type="text" inputmode="numeric" maxlength="6" pattern="[0-9]{6}" required [(ngModel)]="resetOtp">
            </div>
            <button [disabled]="resetLoading() || resetOtp().length !== 6" class="btn-base bg-primary text-white" type="submit">
              @if (resetLoading()) { <i class="fa fa-spinner animate-spin"></i> } @else { Verify code }
            </button>
            <button type="button" class="text-sm text-primary" [disabled]="resetLoading()" (click)="resetStep.set(1)">Use a different email</button>
          </form>
        } @else {
          <small class="mb-8 block text-gray-400">Choose a new password with at least 8 characters.</small>
          <form class="flex flex-col gap-4" (submit)="setNewPassword($event)">
            <div>
              <label for="new-password">New password</label>
              <input id="new-password" name="newPassword" class="w-full" pInputText type="password" minlength="8" required [(ngModel)]="newPassword">
            </div>
            <div>
              <label for="confirm-new-password">Confirm new password</label>
              <input id="confirm-new-password" name="confirmNewPassword" class="w-full" pInputText type="password" minlength="8" required [(ngModel)]="confirmNewPassword">
            </div>
            <button [disabled]="resetLoading() || newPassword().length < 8 || !confirmNewPassword()" class="btn-base bg-primary text-white" type="submit">
              @if (resetLoading()) { <i class="fa fa-spinner animate-spin"></i> } @else { Update password }
            </button>
          </form>
        }
        @if (resetError()) {
          <div role="alert" class="mt-4 text-red-500 bg-red-100 px-4 py-3 rounded-lg">{{ resetError() }}</div>
        }
      } @else {
        <h1 class="h1-title mb-2">Login / Register</h1>
        <small class="mb-8 block text-gray-400">Welcome back ! Please enter your details</small>
        @if (loginError()) {
          <div class="mb-4 text-red-500 bg-red-100  px-4 py-3 rounded-lg"><i class="fa fa-times mr-2"></i>Invalid email or password</div>
        }
        @if (showPassword()) {
          <form [animate.enter]="'animate__fadeInUp'" class="flex flex-col gap-4" appAutoValidate (submit)="onSubmit($event)">
            <div>
              <label for="">Enter Your Email</label>
              <input class="w-full" pInputText type="email" [formField]="loginForm.email">
            </div>
            <div>
              <label for="">Password</label>
              <input class="w-full" pInputText type="password" [formField]="loginForm.password">
            </div>
            <button type="button" class="self-end text-sm text-primary hover:underline" (click)="openPasswordReset()">Forgot password?</button>
            <button [disabled]="loginForm().invalid()" class="btn-base bg-primary text-white" type="submit">
              @if (request.loading()) {
                <i class="fa fa-spinner animate-spin"></i>
              } @else {
                Login
              }</button>
          </form>
        } @else if (showRegister()) {
          <form [animate.enter]="'animate__fadeInUp'" class="flex flex-col gap-4" appAutoValidate (submit)="register($event)">
            <div>
              <label for="">Enter Your Email</label>
              <input class="w-full" pInputText type="email" [formField]="loginForm.email">
            </div>
            <div>
              <label for="">Password</label>
              <input class="w-full" pInputText type="password" [formField]="loginForm.password">
            </div>
            <div>
              <label for="">Confirm Password</label>
              <input class="w-full" pInputText type="password" [formField]="loginForm.confirm_password">
            </div>
            <button [disabled]="loginForm().invalid()" class="btn-base bg-primary text-white" type="submit">
              @if (request.loading()) {
                <i class="fa fa-spinner animate-spin"></i>
              } @else {
                Register
              }</button>
          </form>
        } @else {
          <form [animate.enter]="'animate__fadeInUp'" class="flex flex-col gap-4" appAutoValidate (submit)="validateEmail($event)">
            <div>
              <label for="">Enter Your Email</label>
              <input class="w-full" pInputText type="email" [formField]="loginForm.email">
            </div>
            <button [disabled]="loginForm().invalid()" class="btn-base bg-primary text-white center-all gap-2 hover:gap-4 animate-all" type="submit">
              @if (request.loading()) {
                <i class="fa fa-spinner animate-spin"></i>
              } @else {
                Continue <i class="fa-thin fa-chevron-right text-sm"></i>
              }</button>
          </form>
        }
      }
      <div class="relative">
        <div class="h-[1px] absolute w-full left-0 bg-gray-300 z-0 top-1/2"></div>
        <div class="text-center relative my-8 text-xs z-[10]]"><span class="bg-white px-2">OR CONNECT WITH</span></div>
      </div>
      <div class="flex gap-4">
        <button (click)="tryLogin()" class="social-login-btn">
          <img src="google-logo.svg" class="size-6 m-0! " alt=""> Google
        </button>
        <button class="social-login-btn" (click)="signInWithApple()">
          <img src="apple-logo.svg" class="size-6 m-0! " alt=""> Apple
        </button>
      </div>

      <div class="text-center text-[12px] text-gray-400 pt-8">By continuing your agree to our <a routerLink="/pages/privacy-policy">Term of service</a> and
        <a routerLink="/pages/privacy-policy">Privacy policy</a>
      </div>
    </div>
  </div>
</div>
